/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Placewebcloses2Inputs */

const en_placewebcloses2 = /** @type {(inputs: Placewebcloses2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} closes`)
};

const de_placewebcloses2 = /** @type {(inputs: Placewebcloses2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} schließt`)
};

/**
* | output |
* | --- |
* | "{day} closes" |
*
* @param {Placewebcloses2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebcloses2 = /** @type {((inputs: Placewebcloses2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebcloses2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebcloses2(inputs)
	return de_placewebcloses2(inputs)
});
export { placewebcloses2 as "placeWebCloses" }